export default __webpack_public_path__ + "static/media/loveseat-2-seat-1-back.3ee0147a.webp";